module.exports = __webpack_public_path__ + "img/3-5.11fe8299.png";